import { addCommentHandler } from './AddCommentStmt';
import { removeCommentHandler } from './RemoveCommentStmt';
import { updateCommentHandler } from './UpdateCommentStmt';
export * from './AddCommentStmt';
export * from './RemoveCommentStmt';
export * from './UpdateCommentStmt';
export const structureCommentHandlers = [addCommentHandler, removeCommentHandler, updateCommentHandler];
//# sourceMappingURL=index.js.map